import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { BranchNetworkService } from '../services/branch-network.service';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';

@Component({
  selector: 'branch-network',
  templateUrl: './branch-network.component.html',
  styleUrls: ['../../../../@core/scss/angular/libs/select.component.scss',
              './branch-network.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BranchNetworkComponent implements OnInit {
  public showLoader: boolean = false;
   selectedImage: string | null = null;

  constructor(
    public offerRewardsService: BranchNetworkService,
          public gtmPushService: GTMDataLayerService,
  ) { }

  ngOnInit() { 
    let consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    let moblieNo = "";
    if(consumerData) {
      consumerData = JSON.parse(consumerData);
      moblieNo = consumerData["mobile"];
    }

    let evtObj = {
      "event": "Branch Network",
      "name": "Branch Network",
      "branch_page_visit": "Y",
      "mobile": moblieNo !== "" ? "91"+moblieNo : moblieNo
    };
    this.gtmPushService.dataLayerPushData(evtObj);

    this.selectedImage = 'mumbai'; 
  }
   selectImage(city: string) {
    this.selectedImage = city;
  }
}


